/* ==========================================================================
   Wishes Made Easy — PDP behaviour (design board 2b)

   Progressive enhancement only. With JS blocked the page still renders and
   the form still posts the selected tier to /cart/add, so the store can never
   become un-buyable because a script failed — the same rule the Havern build
   settled on.
   ========================================================================== */

(function () {
  'use strict';

  var roots = document.querySelectorAll('[data-wme-pdp]');
  if (!roots.length) return;

  Array.prototype.forEach.call(roots, function (root) {
    init(root);
  });

  function init(root) {
    var dataEl = root.querySelector('[data-wme-crews]');
    var data = { crews: [], cutoffHour: 14 };
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (e) {
      /* Malformed JSON must not take the buy form down with it. */
    }
    /* P0 honesty: strikes only if Liquid/setting explicitly allows (default off). */
    var showCompareAt = data.showCompareAt === true;

    var form = root.querySelector('[data-wme-form]');
    var variantInput = root.querySelector('[data-wme-variant-input]');
    var occInput = root.querySelector('[data-wme-occ-input]');
    var totalEl = root.querySelector('[data-wme-total]');
    var saveEl = root.querySelector('[data-wme-save]');
    var deliveryEl = root.querySelector('[data-wme-delivery]');
    var tiers = root.querySelectorAll('[data-wme-tier]');
    var bumps = root.querySelectorAll('[data-wme-bump]');
    var worldPackage = root.querySelector('[data-wme-world-package]');
    var comparisonPrice = root.querySelector('[data-wme-comparison-price]');

    var state = {
      crew: data.current,
      tierIndex: indexOfChecked(tiers),
      occWord: occInput ? occInput.value : 'birthday'
    };

    /* ---------- money ---------------------------------------------------- */
    var fmt = new Intl.NumberFormat('en-GB', { style: 'currency', currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'GBP' });
    function money(pennies) {
      return fmt.format((pennies || 0) / 100);
    }

    /* ---------- countdown to the real cutoff ------------------------------ */
    var countdownEl = root.querySelector('[data-wme-countdown]');
    if (countdownEl) {
      tickCountdown();
      setInterval(tickCountdown, 30000);
    }

    function londonParts() {
      var f = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/London',
        hour12: false,
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      });
      var out = {};
      f.formatToParts(new Date()).forEach(function (p) {
        if (p.type !== 'literal') out[p.type] = parseInt(p.value, 10);
      });
      /* Intl renders midnight as 24 in some engines. */
      if (out.hour === 24) out.hour = 0;
      return out;
    }

    function tickCountdown() {
      var now = londonParts();
      var cutoff = data.cutoffHour == null ? 14 : data.cutoffHour;
      var secsNow = now.hour * 3600 + now.minute * 60 + (now.second || 0);
      var secsCut = cutoff * 3600;
      var left = secsCut - secsNow;

      if (left <= 0) {
        /* Past today's cutoff — say so plainly rather than resetting a fake
           timer, which is the one thing the handoff explicitly forbids. */
        countdownEl.textContent = 'ordering for the next filming day';
        countdownEl.hidden = false;
        return;
      }

      var h = Math.floor(left / 3600);
      var m = Math.floor((left % 3600) / 60);
      countdownEl.textContent = h > 0 ? h + 'h ' + m + 'm left' : m + 'm left';
      countdownEl.hidden = false;
    }

    /* ---------- hero: muted autoplay + tap-for-sound (never a dead control) - */
    var hero = root.querySelector('.wme-pdp__hero');
    var video = root.querySelector('[data-wme-hero-video]');
    var soundBtn = root.querySelector('[data-wme-sound]');

    function syncSoundUi() {
      if (!soundBtn) return;
      var paused = !video || video.paused;
      var muted = !video || video.muted || paused;
      soundBtn.setAttribute('aria-label', muted ? 'Play with sound' : 'Mute');
      soundBtn.textContent = muted ? '▶' : '🔊';
      if (hero) {
        hero.classList.toggle('is-playing', !paused);
        hero.classList.toggle('is-unmuted', !muted);
      }
    }

    function tryMutedAutoplay() {
      if (!video) return;
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      var p = video.play();
      if (p && typeof p.catch === 'function') {
        p.catch(function () {
          syncSoundUi();
        });
      }
      syncSoundUi();
    }

    function heroTap(ev) {
      if (!video) return;
      if (ev && ev.preventDefault) ev.preventDefault();
      if (video.paused) {
        video.muted = false;
        var playP = video.play();
        if (playP && typeof playP.catch === 'function') {
          playP.catch(function () {
            video.muted = true;
            var retry = video.play();
            if (retry && retry.catch) retry.catch(function () { video.controls = true; syncSoundUi(); });
            return retry;
          });
        }
      } else {
        video.muted = !video.muted;
        if (!video.muted) video.play();
      }
      syncSoundUi();
    }

    if (video) {
      tryMutedAutoplay();
      video.addEventListener('play', syncSoundUi);
      video.addEventListener('pause', syncSoundUi);
      video.addEventListener('volumechange', syncSoundUi);
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(
          function (entries) {
            for (var i = 0; i < entries.length; i++) {
              if (entries[i].isIntersecting && video.paused) tryMutedAutoplay();
            }
          },
          { threshold: 0.35 }
        );
        io.observe(video);
      }
    }

    if (soundBtn) {
      soundBtn.addEventListener('click', function (ev) {
        ev.stopPropagation();
        heroTap(ev);
      });
    }
    if (hero) hero.addEventListener('click', function (ev) {
      if (ev.target === video) return;
      heroTap(ev);
    });

    /* ---------- step 1 · crew switching, in place ------------------------- */
    var crewBtns = root.querySelectorAll('[data-wme-crew]');
    var heroImg = root.querySelector('[data-wme-hero-img]');
    var crewNameEl = root.querySelector('[data-wme-crew-name]');
    var crewInlineEl = root.querySelector('[data-wme-crew-inline]');

    Array.prototype.forEach.call(crewBtns, function (btn) {
      btn.addEventListener('click', function () {
        var handle = btn.getAttribute('data-wme-crew');
        var crew = findCrew(handle);
        if (!crew) return;

        // Navigate to the actual product so its reviews, media and schema agree.
        if (crew.url) {
          var target = new URL(crew.url, window.location.origin);
          var current = new URL(window.location.href);
          ['occ', 'preview_theme_id'].forEach(function (key) {
            if (current.searchParams.has(key)) target.searchParams.set(key, current.searchParams.get(key));
          });
          var occasionButton = root.querySelector('[data-wme-occ][aria-pressed="true"]');
          if (occasionButton) target.searchParams.set('occ', occasionButton.getAttribute('data-wme-occ'));
          var selected = root.querySelector('[data-wme-tier-name]:checked');
          var tier = selected && selected.getAttribute('data-wme-tier-name');
          if (tier && crew.tiers && crew.tiers[tier]) target.searchParams.set('variant', crew.tiers[tier]);
          window.location.assign(target.toString());
        }
      });
    });

    function findCrew(handle) {
      for (var i = 0; i < data.crews.length; i++) {
        if (data.crews[i].handle === handle) return data.crews[i];
      }
      return null;
    }

    /* Rewrite each tier radio to the newly selected crew's variant + price.
       Radios are Premium-first in the DOM — never index as Basic/Premium/VIP. */
    function retierForCrew(crew) {
      Array.prototype.forEach.call(tiers, function (radio) {
        var key = radio.getAttribute('data-wme-tier-name');
        if (!key || !crew.tiers || !crew.tiers[key]) return;

        radio.value = crew.tiers[key];
        radio.setAttribute('data-wme-price', crew.prices[key]);

        var label = radio.closest('.wme-pdp__pkg');
        if (!label) return;

        var nowEl = label.querySelector('.wme-pdp__pkgnow');
        var wasEl = label.querySelector('.wme-pdp__pkgwas');
        var pctEl = label.querySelector('.wme-pdp__pkgpct');
        var price = crew.prices[key];
        var was = crew.compareAt ? crew.compareAt[key] : 0;

        if (nowEl) nowEl.textContent = money(price);

        /* Unsubstantiated compare-at on live variants must not show as SALE.
           Only reveal strikes when showCompareAt is explicitly true. */
        if (showCompareAt && was && was > price) {
          if (wasEl) {
            wasEl.textContent = money(was);
            wasEl.hidden = false;
          }
          if (pctEl) {
            pctEl.textContent = '−' + Math.round(((was - price) / was) * 100) + '%';
            pctEl.hidden = false;
          }
        } else {
          if (wasEl) wasEl.hidden = true;
          if (pctEl) pctEl.hidden = true;
        }
      });
    }

    /* ---------- step 2 · occasion ----------------------------------------- */
    var occBtns = root.querySelectorAll('[data-wme-occ]');
    var occWordEl = root.querySelector('[data-wme-occ-word]');
    var secondKickers = root.querySelectorAll('[data-wme-second-kicker]');
    function syncSecondKicker() {
      var map = {
        'anniversary': 'Two people or two moments',
        'birthday': 'Perfect for twins, couples or a group surprise',
        'corporate': 'Recognise another teammate'
      };
      var txt = map[state.occWord] || "Add another crew's version";
      Array.prototype.forEach.call(secondKickers, function (el) { el.textContent = txt; });
    }

    Array.prototype.forEach.call(occBtns, function (btn) {
      btn.addEventListener('click', function () {
        var word = btn.getAttribute('data-wme-occ-word');
        state.occWord = word;

        Array.prototype.forEach.call(occBtns, function (b) {
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });

        if (occWordEl) occWordEl.textContent = word;
        if (occInput) occInput.value = word;
        syncSecondKicker();
      });
    });

    var requestedOccasion = new URL(window.location.href).searchParams.get('occ');
    if (requestedOccasion !== null) {
      Array.prototype.forEach.call(occBtns, function (btn) {
        if (btn.getAttribute('data-wme-occ') === requestedOccasion) btn.click();
      });
    }

    syncSecondKicker();

    /* ---------- steps 3 & 4 · totals -------------------------------------- */
    Array.prototype.forEach.call(tiers, function (radio) {
      radio.addEventListener('change', function () {
        if (worldPackage) worldPackage.checked = false;
        state.tierIndex = indexOfChecked(tiers);
        recalc();
      });
    });

    Array.prototype.forEach.call(bumps, function (box) {
      box.addEventListener('change', function () {
        if (box.checked && box.getAttribute('data-wme-extra-handle') !== 'the-works-all-4-extras') {
          var works = root.querySelector('[data-wme-extra-handle="the-works-all-4-extras"]');
          if (box.hasAttribute('data-wme-extra-handle') && works) works.checked = false;
        }
        recalc();
      });
    });

    if (worldPackage) worldPackage.addEventListener('change', recalc);

    var vipUpsell = root.querySelector('[data-wme-select-vip]');
    if (vipUpsell) {
      vipUpsell.addEventListener('click', function () {
        var vipRadio = root.querySelector('[data-wme-tier-name="vip"]');
        if (!vipRadio) return;
        if (worldPackage) worldPackage.checked = false;
        vipRadio.checked = true;
        state.tierIndex = indexOfChecked(tiers);
        recalc();
        vipRadio.closest('.wme-pdp__pkg') &&
          vipRadio.closest('.wme-pdp__pkg').scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      });
    }

    function indexOfChecked(list) {
      for (var i = 0; i < list.length; i++) {
        if (list[i].checked) return i;
      }
      return 0;
    }


    /* ---------- P0-1 Essential sticky (hide + optional bridge) ------------ */
    var STICKY_SELECTORS = [
      '[data-essential-cart-element="essential-sticky-cart-container"]',
      '[data-cart-type="STICKY_ADD_TO_CART"]',
      '#essential-sticky-cart-form-desktop',
      'essential-cart-app-embed [class*="sticky"]'
    ];
    var BRIDGE_FORM_ATTR = 'data-wme-essential-bridge';
    /* Preferred ops fix: hide Essential sticky on this template. */
    var FORCE_HIDE_ESSENTIAL = data.hideEssentialSticky !== false;

    function setEssentialStickyHidden(hidden) {
      for (var s = 0; s < STICKY_SELECTORS.length; s++) {
        var found = document.querySelectorAll(STICKY_SELECTORS[s]);
        for (var i = 0; i < found.length; i++) {
          if (hidden) {
            found[i].setAttribute('hidden', '');
            found[i].setAttribute('data-wme-bridge', 'unavailable');
            found[i].style.setProperty('display', 'none', 'important');
          } else {
            found[i].removeAttribute('hidden');
            found[i].setAttribute('data-wme-bridge', 'ready');
            found[i].style.removeProperty('display');
          }
        }
      }
      if (document.documentElement) {
        document.documentElement.classList.toggle('wme-hide-essential-sticky', !!hidden);
      }
    }

    function ensureBridgeForm() {
      var existing = document.querySelector('form[' + BRIDGE_FORM_ATTR + ']');
      if (existing) return existing;
      var form = document.createElement('form');
      form.setAttribute('action', '/cart/add');
      form.setAttribute('method', 'post');
      form.setAttribute(BRIDGE_FORM_ATTR, '');
      form.setAttribute('aria-hidden', 'true');
      form.style.display = 'none';
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'id';
      input.value = '';
      form.appendChild(input);
      if (root.parentNode) root.parentNode.insertBefore(form, root);
      else document.body.appendChild(form);
      return form;
    }

    function syncEssentialSticky(variantId) {
      if (FORCE_HIDE_ESSENTIAL) {
        setEssentialStickyHidden(true);
        /* Still clear any stale ?variant= Basic so a re-enabled sticky cannot keep it. */
        try {
          var u = new URL(window.location.href);
          if (u.searchParams.has('variant')) {
            u.searchParams.delete('variant');
            window.history.replaceState(null, '', u.pathname + (u.search ? u.search : '') + u.hash);
          }
        } catch (e) {}
        return;
      }
      var form = ensureBridgeForm();
      var input = form.querySelector('input[name="id"]');
      if (!input) return;
      if (variantId) {
        input.value = String(variantId);
        setEssentialStickyHidden(false);
      } else {
        input.value = '';
        setEssentialStickyHidden(true);
      }
      try { input.dispatchEvent(new Event('change', { bubbles: true })); } catch (e) {}
    }

    /* Hide Essential ASAP (before first paint finish) */
    setEssentialStickyHidden(FORCE_HIDE_ESSENTIAL);

    function syncPrivacyOffset() {
      var extra = 0;
      var candidates = document.querySelectorAll(
        '#shopify-pc__banner, .shopify-privacy-banner, [id*="privacy-banner"], .cc-window, .cc-banner'
      );
      for (var i = 0; i < candidates.length; i++) {
        var el = candidates[i];
        if (!el || el.hidden || el.getAttribute('aria-hidden') === 'true') continue;
        var r = el.getBoundingClientRect();
        if (!r.height) continue;
        if (r.bottom > window.innerHeight - 120 && r.top > window.innerHeight * 0.45) {
          extra = Math.max(extra, Math.ceil(r.height));
        }
      }
      document.documentElement.style.setProperty('--wme-privacy-offset', extra + 'px');
    }
    syncPrivacyOffset();
    window.addEventListener('resize', syncPrivacyOffset);
    setTimeout(syncPrivacyOffset, 600);
    setTimeout(syncPrivacyOffset, 2000);

    function recalc() {
      var checkedTier = tiers[state.tierIndex];
      if (!checkedTier) return;

      var total = parseInt(checkedTier.getAttribute('data-wme-price'), 10) || 0;
      var selectedPrice = total;
      var selectedName = checkedTier.getAttribute('data-wme-tier-name') || 'video';
      var isWorld = !!(worldPackage && worldPackage.checked);
      var saved = 0;

      var label = checkedTier.closest('.wme-pdp__pkg');
      if (label) {
        var wasEl = label.querySelector('.wme-pdp__pkgwas');
        if (wasEl && !wasEl.hidden && wasEl.textContent) {
          var wasVal = parseFloat(wasEl.textContent.replace(/[^0-9.]/g, '')) * 100;
          if (wasVal && wasVal > total) saved += wasVal - total;
        }
      }

      var works = root.querySelector('[data-wme-extra-handle="the-works-all-4-extras"]');
      var worksSelected = !!(works && works.checked && selectedName !== 'vip' && !isWorld);
      if (works) works.closest('label').hidden = selectedName === 'vip' || isWorld;
      var messageFields = root.querySelector('[data-wme-world-messages]');
      if (messageFields) {
        messageFields.hidden = !isWorld;
        messageFields.querySelectorAll('textarea').forEach(function (field) { field.disabled = !isWorld; });
      }
      Array.prototype.forEach.call(bumps, function (box) {
        var extraHandle = box.getAttribute('data-wme-extra-handle');
        var included = isWorld || (selectedName === 'vip' && (extraHandle === 'gift-reveal-page' || extraHandle === 'the-works-all-4-extras'));
        if (worksSelected && extraHandle && extraHandle !== 'the-works-all-4-extras') box.checked = false;
        box.disabled = included;
        if (included) box.checked = false;
        var revealRow = box.closest('[data-wme-reveal-extra]');
        if (revealRow) revealRow.hidden = selectedName === 'vip' || isWorld;
        if (box.checked) total += parseInt(box.getAttribute('data-wme-price'), 10) || 0;
      });

      if (isWorld) total = parseInt(worldPackage.getAttribute('data-wme-price'), 10) || 0;
      if (variantInput) variantInput.value = isWorld ? worldPackage.value : checkedTier.value;
      if (comparisonPrice) comparisonPrice.textContent = isWorld ? 'World Tour ' + money(total) + ' total' : (selectedName === 'vip' ? 'VIP' : selectedName.charAt(0).toUpperCase() + selectedName.slice(1)) + ' ' + money(selectedPrice) + ' · download and keep';
      if (vipUpsell) vipUpsell.hidden = selectedName === 'vip' || isWorld;
      if (totalEl) totalEl.textContent = money(total);
      if (saveEl) saveEl.textContent = saved > 0 ? 'save ' + money(saved) : '';
      var sla = checkedTier.getAttribute('data-wme-sla');
      var tierName = checkedTier.getAttribute('data-wme-tier-name') || '';
      if (deliveryEl) {
        if (sla) {
          deliveryEl.textContent = sla;
        } else {
          deliveryEl.textContent =
            tierName === 'basic'
              ? '48–72 hours after we have your details'
              : '24 hours after we have your details';
        }
      }
      if (isWorld && deliveryEl) deliveryEl.textContent = 'Four performances · one gift page';
      root.classList.toggle('is-world-tour', isWorld);
      root.classList.toggle('is-tier-vip', tierName === 'vip');
      root.classList.toggle('is-tier-basic', tierName === 'basic');
      root.classList.toggle('is-tier-premium', tierName === 'premium');

      /* P0 Essential sticky: preferred ops = hide on crew PDPs.
         Bridge sync keeps parent id ready if sticky is re-enabled later. */
      syncEssentialSticky(isWorld ? worldPackage.value : checkedTier.value);
    }

    /* ---------- submit: renumber bump indices ------------------------------ */
    if (form) {
      form.addEventListener('submit', function () {
        var next = 1;
        Array.prototype.forEach.call(bumps, function (box) {
          if (!box.checked) return;
          /* Shopify parses items[] positionally; gaps left by unticked bumps
             would produce null entries, so reindex the checked ones. */
          box.setAttribute('name', 'items[' + next + '][id]');
          next++;
        });
      });
    }

    recalc();
  }
})();
